import { ContainerPositionType, JobDto, WorkInstructionWarningReason } from '@operations/app/api'
import { observer } from 'mobx-react-lite'
import { JobInformationJourney } from '../JobInformation/JobInformationJourney'
import { JobInformationOperationalInstructions } from '../JobInformation/JobInformationOperationalInstructions'
import { JobInformationWrapper } from '../JobInformation/JobInformationWrapper'
import { ConfirmPicks } from './ConfirmPicks'
import { EquipmentOperatorProps } from './edit-destination.interface'

interface Props extends EquipmentOperatorProps {
  job: JobDto
  containerOrigin?: string
  currentStep: number
  stepsTotal: number
  skippedEquipmentAssignment?: boolean
  jobWarningReason?: WorkInstructionWarningReason
  hasError?: boolean
  selectedContainerNumber?: string | null
  handleChange: (hasValue?: boolean) => void
  handleBlockingIssueChange: (hasBlockingIssue: boolean) => void
}

export const EditDestination = observer(
  ({
    job,
    containerOrigin,
    currentStep,
    stepsTotal,
    skippedEquipmentAssignment,
    jobWarningReason,
    hasError,
    ConfirmPickupComponent,
    selectedContainerNumber,
    yardSelector,
    handleChange,
    handleBlockingIssueChange,
    handlePicks,
  }: Props) => {
    return (
      <JobInformationWrapper
        job={job}
        currentStep={currentStep}
        stepsTotal={stepsTotal}
        jobWarningReason={jobWarningReason}
      >
        {job.from.type === ContainerPositionType.Yard && skippedEquipmentAssignment && (
          <ConfirmPicks
            DestinationComponent={ConfirmPickupComponent}
            containerNumber={job.cargoUnit?.displayName ?? ''}
            handlePicks={handlePicks}
          />
        )}
        {(!currentStep || currentStep === 1) && <JobInformationOperationalInstructions job={job} />}
        <JobInformationJourney job={job} origin={containerOrigin}>
          {yardSelector?.({
            containerNumber: selectedContainerNumber ?? job.cargoUnit!.displayName!,
            orderId: job.order?.externalId,
            hasError: hasError,
            journeyId: job.journeyId,
            onPositionChange: value => handleChange(!!value),
            onBlockingIssueChange: handleBlockingIssueChange,
          })}
        </JobInformationJourney>
      </JobInformationWrapper>
    )
  },
)
